import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import { Icon } from '../icon/icon'

export const StyledCardContainer = styled(Grid)`
  border-bottom: ${props => props.theme.typography.pxToRem(1)} solid rgba(86, 86, 86, 0.20);;

  ${props => props.theme.breakpoints.up('md')} {
    border-bottom: none;
    display: flex;
    flex-direction: row;
  }
`

export const StyledTitleText = styled.a`
  color: ${props => props.theme.palette.common.white};
  font-size: ${props => props.theme.typography.pxToRem(18)};
  font-weight: 700;
  text-decoration: none;
  margin: 0;
  transition: margin-right 0.2s ease, color 0.2s ease;
  display: flex;  

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(20)};
    margin-left: 0;
    margin-top: 0;
    line-height: ${props => props.theme.typography.pxToRem(24)};
  }
    
  img {
      filter: grayscale(1);
  }  

  &:hover {
    color: ${props => props.theme.palette.secondary.dark};
  }
`

export const StyledInnerLinkWrapper = styled.a`
    display: flex;
    text-decoration: none;
`

export const StyledTitleCheveron = styled(Icon)`
  color: ${props => props.theme.palette.primary.main};
  margin-top: 0;
  font-size: ${props => props.theme.typography.pxToRem(14)};
  transition: transform 0.2s ease;

  ${props => props.theme.breakpoints.up('sm')} {
    margin-left: ${props => props.theme.typography.pxToRem(4)};
    font-size: ${props => props.theme.typography.pxToRem(16)};
    font-weight: 600;
  }

    ${props => props.theme.breakpoints.up('md')} {
        margin-left: ${props => props.theme.typography.pxToRem(6)};
    }
`

export const StyledQuickLink = styled(Grid)`
  min-width: ${props => props.theme.typography.pxToRem(180)};

  ${props => props.theme.breakpoints.up('md')} {
    padding-left: ${props => props.theme.typography.pxToRem(23)};
    padding-top: 0;  
  }

  &:hover {
    ${StyledTitleCheveron} {
      transform: translateX(${props => props.theme.typography.pxToRem(6)});
    }
    ${StyledTitleText} {
      color: ${props => props.theme.palette.secondary.dark};
    }
  }
`

export const StyledCardWrapper = styled(Grid)`
  flex-direction: column;

  ${props => props.theme.breakpoints.up('md')} {
      flex-direction: row;
      flex-wrap: nowrap;
  }
    
  &:hover {
    ${StyledTitleText} {
      color: ${props => props.theme.palette.secondary.dark};
    }

    ${StyledTitleCheveron} {
      transform: translateX(${props => props.theme.typography.pxToRem(6)});
    }
  }
`


export const StyledTitleGridWrapper = styled(Grid)`
  padding-left: ${props => props.theme.typography.pxToRem(20)};
`

export const StyledChevronGridWrapper = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const StyledCardIconContainer = styled(Grid)`
  margin-bottom: ${props => props.theme.typography.pxToRem(20)};
  display: flex;
  align-items: center;

  ${props => props.theme.breakpoints.up('md')} {
      margin-bottom: 0;
  }

  ${props => props.theme.breakpoints.up('md')} {
    img {
      height: ${props => props.theme.typography.pxToRem(36)};
      width: ${props => props.theme.typography.pxToRem(36)};
    }
  }
`

export const StyledCardList = styled(Grid)`
  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => props.theme.typography.pxToRem(20)};
  }
`
